import {grey, indigo} from '@mui/material/colors'

export const palette = (defaultTheme) => {
    defaultTheme.palette.primary = {
        light: '#8573b6',
        main: '#6750A4',
        dark: '#483872',
        contrastText: grey[50]
    };
    defaultTheme.palette.secondary = {
        light: indigo[50],
        main: indigo[100],
        dark: indigo.A100,
        contrastText: indigo[100],
    };
    defaultTheme.palette.inherit = {
        main: 'rgba(0, 0, 0, 0.87)',

    };
    return defaultTheme;
}
